module.exports = __webpack_public_path__ + "img/az.12ff7398.svg";